import api from '../services/config/api';

export const changeStatusDemand = (demandId: number, newStatus: string) =>
  api.patch(`/solicitacao/${demandId}?status=${newStatus}`);
